import {
  GET_PERFORMANCEAPPRAISAL,
  GET_PERFORMANCEAPPRAISAL_SUCCESS,
  GET_PERFORMANCEAPPRAISAL_FAIL,
  DELETE_PERFORMANCEAPPRAISAL,
  DELETE_PERFORMANCEAPPRAISAL_SUCCESS,
  DELETE_PERFORMANCEAPPRAISAL_FAIL,
  UPDATE_PERFORMANCEAPPRAISAL,
  UPDATE_PERFORMANCEAPPRAISAL_SUCCESS,
  UPDATE_PERFORMANCEAPPRAISAL_FAIL,
  ADD_NEW_PERFORMANCEAPPRAISAL,
  ADD_PERFORMANCEAPPRAISAL_SUCCESS,
  ADD_PERFORMANCEAPPRAISAL_FAIL,
  PERFORMANCEAPPRAISAL_LOADING,
  PERFORMANCEAPPRAISAL_RESET,
} from "./actionType";

export const resetPerformanceAppraisalState = (actionType) => ({
  type: PERFORMANCEAPPRAISAL_RESET,
  payload: { actionType },
});

export const getPerformanceAppraisalSuccess = (actionType, data) => ({
  type: GET_PERFORMANCEAPPRAISAL_SUCCESS,
  payload: { actionType, data },
});

export const getPerformanceAppraisalFail = (actionType, error) => ({
  type: GET_PERFORMANCEAPPRAISAL_FAIL,
  payload: { actionType, error },
});

export const getPerformanceAppraisal = data => ({
  type: GET_PERFORMANCEAPPRAISAL,
  payload: data,
});

export const getPerformanceAppraisalLoading = () => ({
  type: PERFORMANCEAPPRAISAL_LOADING
});

export const deletePerformanceAppraisal = data => ({
  type: DELETE_PERFORMANCEAPPRAISAL,
  payload: data,
});

export const deletePerformanceAppraisalSuccess = data => ({
  type: DELETE_PERFORMANCEAPPRAISAL_SUCCESS,
  payload: data,
});

export const deletePerformanceAppraisalFail = error => ({
  type: DELETE_PERFORMANCEAPPRAISAL_FAIL,
  payload: error,
});

export const updatePerformanceAppraisal = data => ({
  type: UPDATE_PERFORMANCEAPPRAISAL,
  payload: data,
});

export const updatePerformanceAppraisalFail = error => ({
  type: UPDATE_PERFORMANCEAPPRAISAL_FAIL,
  payload: error,
});

export const updatePerformanceAppraisalSuccess = data => ({
  type: UPDATE_PERFORMANCEAPPRAISAL_SUCCESS,
  payload: data,
});

export const addNewPerformanceAppraisal = data => ({
  type: ADD_NEW_PERFORMANCEAPPRAISAL,
  payload: data,
});

export const addPerformanceAppraisalSuccess = data => ({
  type: ADD_PERFORMANCEAPPRAISAL_SUCCESS,
  payload: data,
});

export const addPerformanceAppraisalFail = error => ({
  type: ADD_PERFORMANCEAPPRAISAL_FAIL,
  payload: error,
});